import React, { useState, useEffect } from "react";
import {
  useParams,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import { Button, Col, Row, Space, Typography } from "antd";
import StackedText from "../Common/StackedText";
import "./assetDetails.css";
import { useAuth } from "../../Context/authContext";
import { formatReleaseDate, getSourceValueLabel } from "../Common/Utils";
import SourceValue from "../Common/SourceValue";

const { Title, Text } = Typography;

function AssetDetails() {
  const [asset, setAsset] = useState<any>(null);
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useAuth();
  useEffect(() => {
    if (!auth.user.isAdmin) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (location.state?.data) {
      setAsset(location.state.data);
    }
  }, [location]);

  const formatDateField = (value) => ({
    value: formatReleaseDate(value) || "",
    sourceLabel: getSourceValueLabel(value),
  });

  // Configuration for the Left Column
  const leftFields = [
    {
      label: "Artist",
      value: asset?.resourceReleaseInfo?.artists || asset?.artist,
    },
    {
      label: "Album",
      value: asset?.resourceReleaseInfo?.album || asset?.album,
    },
    {
      label: "Track",
      value: asset?.resourceReleaseInfo?.trackTitle || asset?.track,
    },
    { label: "UPC", value: asset?.resourceReleaseInfo?.upc || asset?.upc },
    { label: "ISRC", value: asset?.resourceReleaseInfo?.isrc || asset?.isrc },
    {
      label: "Release Date",
      ...formatDateField(asset?.resourceReleaseInfo?.releaseDate),
    },
    { label: "Submission Date", ...formatDateField(asset?.modifiedOn) },
    { label: "RightsType", value: asset?.resourceReleaseInfo?.rightsType },
    {
      label: "First Delivery Date",
      ...formatDateField(asset?.deliveryInfo?.[0]?.firstDeliveryDate),
    },
    {
      label: "Last Delivery Date",
      ...formatDateField(asset?.deliveryInfo?.[0]?.lastDeliveryDate),
    },
    { label: "Notes", value: asset?.notes },
  ];

  // Configuration for the Right Column
  const rightFields = [
    { label: "FileName", value: asset?.fileName },
    { label: "Watermark", value: asset?.watermark, isStacked: true },
    { label: "Status", value: asset?.status, isStacked: true },
    { label: "Format", value: asset?.format },
    { label: "Size", value: asset?.size },
    { label: "Platform", value: asset?.watermarks?.platform },
    { label: "Reference #", value: asset?.uploadKey },

    { label: "Uploaded By", value: asset?.modifiedBy },
    { label: "Watermark User", value: asset?.watermarks?.watermarkedUser },
    { label: "Watermark Email", value: asset?.watermarks?.watermarkedEmail },
    { label: "Original WM Date", value: asset?.watermarks?.watermarkDate },
  ];

  const renderGridRows = (fields: any[]) => (
    <div className="asset-details-grid">
      {fields.map((field, index) => (
        <React.Fragment key={index}>
          <Text className="left-title">{field.label}</Text>
          <div className="right-value">
            {field.isStacked ? (
              <StackedText value={field.value} />
            ) : (
              <Text>
                <SourceValue
                  value={field.value}
                  sourceLabel={field.sourceLabel}
                />
              </Text>
            )}
          </div>
        </React.Fragment>
      ))}
    </div>
  );

  return (
    <div className="custom-container detail-page-bg">
      <Row justify="space-between" align="middle">
        <Col>
          <Title className="page-title">ASSET DETAILS</Title>
        </Col>
        <Col>
          <Button onClick={() => navigate("/search")} type="primary">
            {"<"} BACK
          </Button>
        </Col>
      </Row>

      <Row gutter={64} style={{ marginTop: "40px" }}>
        {asset && (
          <>
            <Col span={12}>{renderGridRows(leftFields)}</Col>
            <Col span={12}>{renderGridRows(rightFields)}</Col>
          </>
        )}
      </Row>
    </div>
  );
}

export default AssetDetails;
